import { render } from "./Portfolios.vue?vue&type=template&id=9b0c5830&scoped=true"
import script from "./Portfolios.vue?vue&type=script&lang=js"
export * from "./Portfolios.vue?vue&type=script&lang=js"

import "./Portfolios.vue?vue&type=style&index=0&id=9b0c5830&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b0c5830"]])

export default __exports__